import { useContext } from 'react';
import GlobalStateContext from '../../context/GlobalStateContext';

function useTranscriptSelectionPaginationData() {
  const { lastNavigatedTranscriptSelectionPage } = useContext(GlobalStateContext);

  return { lastNavigatedTranscriptSelectionPage };
}

export default useTranscriptSelectionPaginationData;
